import API from 'utils/api';
import { onError, onSuccess } from 'utils/handlers';

export const baseURI = '/usuarios/usuarios-limitaciones-de-administracion-de-plazas/';

/**
 * GET Lista de Limitaciones de Administración de Plazas
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getLimitacionesAdministracionPlazas = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Limitación de Administración de Plazas individual
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getLimitacionAdministracionPlazas = async (id) => {
  try {
    const response = await API.get(`${baseURI}${id}/`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST Crear Limitación de Administración de Plazas
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postLimitacionAdministracionPlazas = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Editar Limitación de Administración de Plazas
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchLimitacionAdministracionPlazas = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}/`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Eliminar Limitación de Administración de Plazas
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteLimitacionAdministracionPlazas = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}/`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
